import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import CKEditorText from "@components/CKEditorText/CKEditorText";
import commentIcon from "@icons/ic-comment-blue.svg";
import { Image } from "hesus-ui-kit";
import { ContainerLabel } from "../../AddEditInvoice.styled";

const CommentEditor = ({
  t,
  type,
  label,
  value,
  isEditorOpen,
  setEditorOpen,
  setDescriptionData,
  alwaysOpen = false,
}) => {
  const handleChange = (newValue) => {
    setDescriptionData((prev) => ({
      ...prev,
      [type]: newValue,
    }));
  };

  const handleOpen = (event) => {
    event.preventDefault();

    setEditorOpen((prev) => ({
      ...prev,
      [type]: true,
    }));
  };

  // Internal comment is always open
  if (alwaysOpen) {
    return (
      <div>
        <ContainerLabel htmlFor="description">{t(label)}</ContainerLabel>
        <CKEditorText
          descriptionData={value}
          setDescriptionData={handleChange}
          maxHeight="auto"
        />
      </div>
    );
  }

  return (
    <>
      <ContainerLabel
        htmlFor={`${type}-description`}
        onClick={!isEditorOpen ? handleOpen : undefined}
        cursor={!isEditorOpen ? "pointer" : "default"}
        textDecoration={!isEditorOpen ? "underline" : "none"}
      >
        <Image
          src={commentIcon}
          alt={t("commentIcon")}
          title={t("commentIcon")}
          styles={{ width: "auto", marginRight: "10px" }}
        />

        {t(label)}
      </ContainerLabel>

      {isEditorOpen && (
        <CKEditorText
          descriptionData={value || ""}
          setDescriptionData={handleChange}
          maxHeight="80px"
        />
      )}
    </>
  );
};

export default withTranslation()(CommentEditor);
